<template>
  <div>
    <v-alert
      :prominent="!$vuetify.breakpoint.xs"
      class="ma-0 rounded-t-0"
      color="primary"
      text
    >
      Du hast folgende Geräte ausgeliehen. Bitte bringe sie bis zum angegeben
      Datum zurück, damit andere sie nutzen können.
    </v-alert>
    <v-card :class="`v-alert--text primary--text rounded-t-0`" flat tile>
      <v-list>
        <v-list-item v-for="item in items" :key="item.id">
          <v-list-item-icon
            ><v-icon
              >{{
                deviceTypeIcon(
                  item.device ? item.device.deviceType : item.deviceType
                )
              }}
            </v-icon></v-list-item-icon
          >
          <v-list-item-content v-if="item.device">
            <v-list-item-title
              >{{ item.device.deviceType.description }} «{{ item.device.name }}»
            </v-list-item-title>

            <v-list-item-subtitle
              >{{ item.device.brandModel.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title
              >{{ item.deviceType.description }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.comment"
              >{{ item.comment }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  :color="isPastDate(item.dueDate) ? 'danger' : 'primary'"
                >
                  <DateValue v-if="item.dueDate" :value="item.dueDate" />
                  <span v-else>kein Rückgabedatum</span>
                </v-chip>
              </template>
              <span v-if="item.dueDate"
                >Bitte bis
                <DateValue :value="item.dueDate" full />
                zurückbringen.</span
              >
              <span v-else
                >Bitte zurückbringen, falls nicht mehr verwendet.</span
              >
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import DateValue from "common/components/DateValue.vue";

import { isPastDate } from "common/utils/date";
import { deviceTypeIcon } from "common/utils/icons";

export default defineComponent({
  name: "Loan",
  components: {
    DateValue,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {},
  methods: {
    isPastDate,
    deviceTypeIcon,
    async fetchData() {
      this.items = await this.apiList({
        resource: "inventory/activity",
      });

      if (this.items.length > 0) {
        this.$emit("loaded");
      }
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
